import { FullStoryAPI } from 'react-fullstory'

export const fullStoryIdentify = (userId, data) => {
  FullStoryAPI('identify', userId, data)
}

export const fullStoryTrack = ({ eventName, eventProperties = {} }) => {
  FullStoryAPI('event', eventName, eventProperties)
}
